import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { keHoachThucTapPhamViApi } from "../../../api/xet-thuc-tap/keHoachThucTapPhamViApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eKeHoachThucTapPhamViActionIds, IKeHoachThucTapPhamViActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapPhamViActions";
import { rootActions } from "../../actions/rootActions";
import { eKeHoachThucTapActionIds } from "../../action-types/xet-thuc-tap/IKeHoachThucTapActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* keHoachThucTapPhamViSaga(): any {
    yield takeLatest(eKeHoachThucTapPhamViActionIds.LOAD_BY_DOT_THUC_TAP_START, loadByDotXetWorker);
    yield takeEvery(eKeHoachThucTapPhamViActionIds.INSERT_START, addWorker);
    yield takeEvery(eKeHoachThucTapPhamViActionIds.DELETE_START, deleteWorker);
}


function* loadByDotXetWorker(action: IKeHoachThucTapPhamViActionTypes) {
    const id_dot_thuc_tap = action.payload as number;
    const response : IBaseResponse = yield keHoachThucTapPhamViApi.SelectByDotThucTap(id_dot_thuc_tap);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamVi.LOAD_BY_DOT_THUC_TAP_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamVi.LOAD_BY_DOT_THUC_TAP_ERROR(response.message ?? "Lỗi khi tải phạm vi kế hoạch thực tập"));
    }
}

function* addWorker(action: IKeHoachThucTapPhamViActionTypes) {
    const data = action.payload;
    const response: IBaseResponse = yield keHoachThucTapPhamViApi.Insert(data);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamVi.INSERT_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamVi.INSERT_ERROR(response.message ?? "Lỗi khi thêm phạm vi kế hoạch thực tập"));
    }
}

function* deleteWorker(action: IKeHoachThucTapPhamViActionTypes) {
    const id = action.payload as number;
    const response: IBaseResponse = yield keHoachThucTapPhamViApi.Delete(id);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamVi.DELETE_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTapPhamVi.DELETE_ERROR(response.message ?? "Lỗi khi xóa phạm vi kế hoạch thực tập"));
    }
}